import { makeStyles } from "@material-ui/core/styles";

// eslint-disable-next-line no-unused-vars
export default makeStyles(theme => ({
  logout: {
    bottom: 0,
    left: 0,
    position: "absolute"
  },
  list: {
    height: "87vh"
  },
  icon: {
    minWidth: 40
  }
}));
